import { Container } from '@chakra-ui/react';

const Layout = ({ children }) => (
  <Container as="main" maxW="full" mx="0" px="0">
    {children}
  </Container>
);

export default Layout;
